const PriceCard = ({ a, b }) => {
  return <div className='bg-chCard-background rounded-md w-[210px] ml-auto mr-auto p-4 text-center border-1 border-primary'>
  <div className='text-statValue font-bold text-2xl'>{a}</div>
  <div className='text-statLabel'>{b}</div>
  </div>
}

export default PriceCard